import React from 'react';
import PropTypes from 'prop-types';
import ResultLink from '../../../shared/links/ResultLink';
import formatWeight from '../../../utils/formatWeight';
import { formatWinDist } from '../../../utils/distance';

const HorseCell = ({
    profileType,
    courseName,
    courseUid,
    raceInstanceUid,
    raceDatetime,
    rpCloseUpComment,
    rpBettingMovements,
    horseStyleName,
    raceOutcomeCode,
    winningDistance,
    distanceToWinner,
    weightCarriedLbs,
    horseHeadGear,
}) => (
    <ResultLink
        courseName={courseName}
        courseUid={courseUid}
        raceInstanceUid={raceInstanceUid}
        raceDatetime={raceDatetime}
        raceInstanceTitle={
            `${rpCloseUpComment}${rpBettingMovements ? ` (${rpBettingMovements})` : ''}`
        }
        cssClass={'mp-form__disabledOnNarrow'}
        showAfter={false}
    >
        <span className="hidden-xs-down">
            {formatWinDist(raceOutcomeCode, winningDistance, distanceToWinner)}
        </span>
        {horseStyleName}
        {weightCarriedLbs && profileType === 'jockey' &&
            <span className="hidden-xs-down">
                &nbsp;
                {formatWeight(weightCarriedLbs)}
            </span>
        }
        <span className="hidden-sm-down">
            &nbsp;
            {horseHeadGear}
        </span>
    </ResultLink>
);

HorseCell.propTypes = {
    profileType: PropTypes.string,
    courseName: PropTypes.string,
    courseUid: PropTypes.number,
    raceInstanceUid: PropTypes.number,
    raceDatetime: PropTypes.string,
    rpBettingMovements: PropTypes.string,
    rpCloseUpComment: PropTypes.string,
    horseStyleName: PropTypes.string,
    raceOutcomeCode: PropTypes.string,
    winningDistance: PropTypes.string,
    distanceToWinner: PropTypes.string,
    weightCarriedLbs: PropTypes.number,
    horseHeadGear: PropTypes.string,
};

export default HorseCell;



// WEBPACK FOOTER //
// ./src/js/human/form/components/HorseCell.jsx